exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./images/text_height.svg"));

// Module
exports.push([module.id, ".widget-editor .values_three .widget-icon {\n  background: url(" + ___CSS_LOADER_URL___0___ + ") no-repeat !important;\n  opacity: 1 !important; }\n\n.widget-editor .values_three:hover .widget-icon {\n  filter: brightness(0.7); }\n\n.widget-editor .values_three.active .widget-icon {\n  filter: grayscale(1); }\n", ""]);

